<button
    mat-button
    color="warn"
    (click)="canDelete ? deleteBoard() : prepareForDelete()"
    >

    <mat-icon>delete</mat-icon>
    <span *ngIf="canDelete">confirm</span>

</button>